export const CaptureMode = {
    REVIEWS: 'REVIEWS',
    USERS: 'USERS'
}
